import React from 'react';

import EPButton from './EPButton';

interface EPButtonProps {
  children?: JSX.Element | string;
  [x: string]: unknown;
  icon: React.ReactNode;
}

const EPIconButton = ({ icon, ...rest }: EPButtonProps) => {
  return <EPButton icon={icon} type="text" size="medium" {...rest} />;
};

export default EPIconButton;
